import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgPin(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M15.75 7.75C13.1266 7.75 11 9.87665 11 12.5C11 15.1234 13.1266 17.25 15.75 17.25C18.3734 17.25 20.5 15.1234 20.5 12.5C20.5 9.87665 18.3734 7.75 15.75 7.75ZM13.5 12.5C13.5 11.2574 14.5074 10.25 15.75 10.25C16.9926 10.25 18 11.2574 18 12.5C18 13.7426 16.9926 14.75 15.75 14.75C14.5074 14.75 13.5 13.7426 13.5 12.5Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M13.3104 28.2788C13.7773 28.7819 14.1673 29.1843 14.442 29.4622C14.4881 29.5089 14.6152 29.6346 14.7219 29.7402C14.8236 29.8408 14.9067 29.923 14.883 29.9005C15.3671 30.3665 16.1329 30.3665 16.617 29.9005C16.766 29.7565 16.9124 29.6096 17.058 29.4622C17.3327 29.1843 17.7227 28.7819 18.1896 28.2788C19.1222 27.274 20.3684 25.8602 21.6177 24.2277C22.864 22.599 24.1324 20.7281 25.094 18.8099C26.0472 16.9086 26.75 14.8609 26.75 12.9048C26.75 6.76279 21.8436 1.75 15.75 1.75C9.65638 1.75 4.75 6.76279 4.75 12.9048C4.75 14.8609 5.45285 16.9086 6.40599 18.8099C7.36757 20.7281 8.63601 22.599 9.88231 24.2277C11.1316 25.8602 12.3778 27.274 13.3104 28.2788ZM15.75 4.25C11.0741 4.25 7.25 8.10624 7.25 12.9048C7.25 14.3028 7.7659 15.9441 8.64089 17.6895C9.50743 19.4181 10.6765 21.1517 11.8677 22.7084C13.0559 24.2611 14.2472 25.6132 15.1428 26.5781C15.3654 26.818 15.5694 27.0336 15.75 27.2218C15.9306 27.0336 16.1346 26.818 16.3572 26.5781C17.2528 25.6132 18.4441 24.2611 19.6323 22.7084C20.8235 21.1517 21.9926 19.4181 22.8591 17.6895C23.7341 15.9441 24.25 14.3028 24.25 12.9048C24.25 8.10624 20.4259 4.25 15.75 4.25Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgPin);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
